"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSplitLinks = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FooterLink_atom_1 = require("../atoms/FooterLink.atom");
const Subtitle_atom_1 = require("../atoms/Subtitle.atom");
const classnames_1 = __importDefault(require("classnames"));
const Styled = styled_components_1.default.div `
    .subtitle {
        display: block;
    }
    a {
        padding-left: 0;
        display: block;
    }

    .split {
        margin: 16px 0;

        .columns {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: flex-start;
            justify-content: flex-start;
            align-items: flex-start;

            .column {
                display: inline-block;
                margin-right: 16px;
            }
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .split {
            .columns {
                align-content: center;
                justify-content: space-evenly;
            }
        }
    }

    ${(p) => p.theme.breakpoints.down('xs')} {
        .split {
            .columns {
                flex-direction: column;
                text-align: center;
                align-content: stretch;
                align-items: center;
                .column {
                    margin-right: 0;
                }
            }
        }
    }

    &.ar {
        .split .columns .column {
            margin-right: initial;
            margin-left: 16px;
        }
    }
`;
const SplitLinks = ({ subTitle = '', links = [] }) => {
    if (!links || !links.length)
        return null;
    let one = [];
    let two = [];
    let three = [];
    const len = links.length;
    // more than 4 items split in half
    if (len >= 4 && len < 9) {
        const split = Math.ceil(len / 2);
        one = links.slice(0, split);
        two = links.slice(split, len);
    }
    else if (len >= 9) {
        const firstColumnAmount = Math.ceil(len / 3);
        one = links.slice(0, firstColumnAmount);
        const totalLeft = len - firstColumnAmount;
        const split = Math.ceil(totalLeft / 2);
        two = links.slice(firstColumnAmount, firstColumnAmount + split);
        three = links.slice(firstColumnAmount + split, len);
    }
    else {
        one = links;
    }
    return (react_1.default.createElement("div", { className: "split" },
        react_1.default.createElement(Subtitle_atom_1.Subtitle, { subTitle: subTitle, split: true }),
        react_1.default.createElement("div", { className: "columns" },
            one.length ? (react_1.default.createElement("div", { className: "column one" }, one.map((link) => {
                return react_1.default.createElement(FooterLink_atom_1.FooterLink, Object.assign({ key: link.title }, link));
            }))) : (''),
            two.length ? (react_1.default.createElement("div", { className: "column two" }, two.map((link) => {
                return react_1.default.createElement(FooterLink_atom_1.FooterLink, Object.assign({ key: link.title }, link));
            }))) : (''),
            three.length ? (react_1.default.createElement("div", { className: "column three" }, three.map((link) => {
                return react_1.default.createElement(FooterLink_atom_1.FooterLink, Object.assign({ key: link.title }, link));
            }))) : (''))));
};
const AutoSplitLinks = ({ links = [], secondaryLinks = [], mainLinksSubTitle, secondaryLinksSubTitle, locale }) => {
    return (react_1.default.createElement(Styled, { className: (0, classnames_1.default)('auto-slit-links', locale) },
        react_1.default.createElement(SplitLinks, { links: links, subTitle: mainLinksSubTitle }),
        react_1.default.createElement(SplitLinks, { links: secondaryLinks, subTitle: secondaryLinksSubTitle })));
};
exports.AutoSplitLinks = AutoSplitLinks;
//# sourceMappingURL=AutoSplitLinks.molecule.js.map